"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ProductsController =
/*#__PURE__*/
function () {
  function ProductsController(loadedData, category, lang) {
    var _this2 = this;

    _classCallCheck(this, ProductsController);

    this.productsList = loadedData.productsList;
    this.category = category;
    this.lang = lang;
    this.products = $('#productsList');
    this.document = $(document);
    this.container = $('section.products table tbody');
    this.form = $('#form');
    this.button = $('button.button');
    this.priceTotal = 0;
    this.priceTotalHolder = $('#priceTotal span span');
    this.priceVirtualKit = [];

    var _this = this;

    this.document.on('click', '.remove > i', function () {
      _this.removeProduct($(this).parents('tr'));
    });
    this.checkFormFocus();
    this.checkForEmptyTable();
    this.addProduct();
    this.category.categoriesElement.on('change', function (event) {
      _this2.watchSelectedCategory(event.currentTarget.selectedOptions[0].value);

      $(event.currentTarget).parent().removeClass('error');
    });
    this.products.on('change', function (event) {
      $(event.currentTarget).parent().removeClass('error');
    });
    this.scrollToAddNextProduct();
  }

  _createClass(ProductsController, [{
    key: "checkFormFocus",
    value: function checkFormFocus() {
      var _this = this;

      $('select').focus(function () {
        _this.form.removeClass('highlight');

        _this.button.removeClass('highlight');
      });
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    }
  }, {
    key: "scrollToAddNextProduct",
    value: function scrollToAddNextProduct() {
      var _this = this;

      $("#add-product").click(function (event) {
        event.preventDefault();

        _this.form.addClass('highlight');

        _this.button.addClass('highlight');

        $([document.documentElement, document.body]).animate({
          scrollTop: $("header").offset().top
        }, 1000);
      });
    }
  }, {
    key: "watchSelectedCategory",
    value: function watchSelectedCategory(selectedCategory) {
      this.getProductsList(selectedCategory);
    }
  }, {
    key: "getProductsList",
    value: function getProductsList(selectedCategory) {
      var selectedProducts = Object.values(this.productsList);
      var filteredProducts = selectedProducts.filter(function (selectedProduct) {
        return selectedProduct.category == selectedCategory;
      });
      this.setProducts(filteredProducts);
    }
  }, {
    key: "setProducts",
    value: function setProducts(dataList) {
      var _this3 = this;

      dataList = Object.values(dataList);
      this.products.html('<option value="" selected="" disabled="">Produkt</option>');
      dataList.sort(function (a, b) {
        var item1 = a.title.toUpperCase();
        var item2 = b.title.toUpperCase();
        return item1 < item2 ? -1 : item1 > item2 ? 1 : 0;
      });
      dataList.forEach(function (data) {
        _this3.products.append('<option value="' + data.id + '">' + data.title + '</option>');
      });
    }
  }, {
    key: "checkForEmptyTable",
    value: function checkForEmptyTable() {
      var tableRow = $('table tbody tr');
      var emptyRow = $('#empty');

      if (tableRow.length >= 2) {
        emptyRow.hide(0);
      } else {
        emptyRow.show(0);
        this.priceTotal = 0;
      }
    }
  }, {
    key: "calculatePrice",
    value: function calculatePrice() {
      var bonusWithoutVirtualKit = 0;
      $('tr.bonus').each(function () {
        bonusWithoutVirtualKit = +bonusWithoutVirtualKit + +$(this).data('bonus');
      });

      if (this.priceVirtualKit.length > 0) {
        this.priceTotal = +bonusWithoutVirtualKit + +Math.max.apply(Math, _toConsumableArray(this.priceVirtualKit));
      } else {
        this.priceTotal = +bonusWithoutVirtualKit;
      }

      this.priceTotalHolder.text(this.formatNumber(this.priceTotal));
    }
  }, {
    key: "removeVirtualKit",
    value: function removeVirtualKit(array, value) {
      var index = array.indexOf(String(value));

      if (index !== -1) {
        array.splice(index, 1);
      }
    }
  }, {
    key: "removeProduct",
    value: function removeProduct(element) {
      var removeBonus = element.data('bonus');
      var removeVirtualKitBonus = element.data('virtualKitBonus');
      element.detach();
      this.priceTotal = +this.priceTotal - +removeBonus;
      this.removeVirtualKit(this.priceVirtualKit, removeVirtualKitBonus);
      this.calculatePrice();
      this.checkForEmptyTable();
      this.priceTotalHolder.text(this.formatNumber(this.priceTotal));
    }
  }, {
    key: "addProduct",
    value: function addProduct() {
      var _this4 = this;

      this.form.submit(function (event) {
        event.preventDefault();
        var productId = null;
        var categoryId = null;
        productId = $('select[name=product]').val();
        categoryId = $('select[name=category]').val();

        if (productId === null) {
          $('select[name=product]').parent().addClass('error');
        }

        if (categoryId === null) {
          $('select[name=category]').parent().addClass('error');
        }

        if (categoryId !== null && productId !== null) {
          var selectedProduct = null;
          _this4.productsList = Object.values(_this4.productsList);

          _this4.productsList.forEach(function (product) {
            if (productId == product.id) {
              selectedProduct = product;
            }
          });

          var productBonus = 0;
          var virtualKitPrice = 0;
          var item = selectedProduct.promotions.map(function (promotion) {
            var isVirtualKit = '';

            if (promotion.promotion_title === "Canon Virtual Kit") {
              isVirtualKit = language[_this4.lang]['langMainDiscountCondition'];

              _this4.priceVirtualKit.push(promotion.bonus);

              virtualKitPrice = promotion.bonus;
            } else if (!isNaN(promotion.bonus)) {
              productBonus = +productBonus + +promotion.bonus;
            }

            return '<tr><td><a href="' + promotion.link + '" target="_blank"><strong>' + promotion.promotion_title + '</strong></a></td><td>' + promotion.valid_from + ' - ' + promotion.valid_to + '<br><small>' + promotion.tc_short + '</small><small><strong>' + isVirtualKit + '</strong></small></td><td><strong>' + promotion.bonus_descr + '</strong></td></tr>';
          }).join('');

          _this4.container.append('<tr class="bonus" data-virtual-kit-bonus="' + virtualKitPrice + '" data-bonus="' + productBonus + '">\
					<td><img src="https://creativenow.cz' + selectedProduct.image + '" alt="' + selectedProduct.title + '"/></td>\
					<td><strong>' + selectedProduct.title + '</strong></td>\
					<td colspan="3" class="table-holder"><table><tbody>' + item + '</tbody></table></td>\
					<td class="remove"><i class="fas fa-times-circle"></i></td>\
				</tr>');

          _this4.checkForEmptyTable();

          _this4.form[0].reset();

          _this4.calculatePrice();

          $([document.documentElement, document.body]).animate({
            scrollTop: $("section.products").offset().top
          }, 1000);
        }
      });
    }
  }]);

  return ProductsController;
}();